module.exports = __webpack_public_path__ + "img/fail.9771741c.png";